import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFailoverH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 15a5 5 0 0 0-5 5v39a5 5 0 0 0 5 5h28a5 5 0 0 0 5-5V20a5 5 0 0 0-5-5h-.5a1 1 0 0 1 0-2h.5a7 7 0 0 1 7 7v39a7 7 0 0 1-7 7H22a7 7 0 0 1-7-7V20a7 7 0 0 1 7-7h.5a1 1 0 1 1 0 2zM44.839 10.661c-4.882-4.881-12.796-4.881-17.678 0a1 1 0 0 1-1.414-1.414c5.663-5.663 14.843-5.663 20.506 0a1 1 0 1 1-1.414 1.414",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40.596 13.904a6.5 6.5 0 0 0-9.192 0 1 1 0 0 1-1.414-1.414 8.5 8.5 0 0 1 12.02 0 1 1 0 0 1-1.414 1.414",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.414 18.914a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 59a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  }));
}
var IcFailoverH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFailoverH72));

export { IcFailoverH72 as I };
